import { BRIDGE_EVENT } from '../constants'

export const callbacks: any = {}
let isListenerInited = false

function initListener(): void {
  ;(window as any).addEventListener(BRIDGE_EVENT, (e: CustomEvent): void => {
    if (e && e.detail && e.detail.type && callbacks[e.detail.type]) {
      callbacks[e.detail.type].forEach((callback: any): void => callback(e))
    }
  })
}

type ClientCallback = (e: CustomEvent) => void

export function addListener(type: string, callback: ClientCallback): void {
  if (!isListenerInited) {
    isListenerInited = true
    initListener()
  }
  if (callbacks[type]) {
    callbacks[type].push(callback)
  } else {
    callbacks[type] = [callback]
  }
}
